import { Component, OnInit } from '@angular/core';
import { AdminService } from '../admin.service';
import {MyQueriesService} from './my-query.service';
import * as fileSaver from 'file-saver';

@Component({
  selector: 'app-my-queries',
  templateUrl: './my-queries.component.html',
  styleUrls: ['./my-queries.component.css']
})
export class MyQueriesComponent implements OnInit {
  isQueriesLoading: boolean;
  queryList: any[] = [];
  selectedQuery: any = {};

  constructor(
    private myQueriesService: MyQueriesService,
    private adminService: AdminService
  ) { }

  ngOnInit(): void {
    this.isQueriesLoading = false;
    this.loadQueries();
  }

  loadQueries() {
    this.isQueriesLoading = true;
    this.myQueriesService.queryList().subscribe((data: any) => {
      this.queryList = data.success.userQuery;
      this.isQueriesLoading = false;
    });
  }

  onSelectQuery(queryId: any) {
    this.adminService.details({ Id: queryId }).subscribe((data: any) => {
      this.selectedQuery = data.success.userQuery;
    });
  }

  downloadDocument(data:any){
    this.myQueriesService.downloadDocument({filename: data.attachFile[1], path: data.attachFile[0]})
    .subscribe(response => {
      fileSaver.saveAs(response, data.attachFile[1]);
    });
  }

}
